/**
 * Employer dashboard shell + nested pages.
 */
import React from "react";
import { Route, Navigate } from "react-router-dom";

import EmployerLayout from "@/pages/employer/EmployerLayout";
import EmployerDashboardV2 from "@/pages/employer/EmployerDashboardV2";
import EmployerJobs from "@/pages/employer/EmployerJobs";
import EmployerDashboard from "@/pages/EmployerDashboard";
import FindTalent from "@/pages/employer/FindTalent";
import CandidatePipeline from "@/pages/employer/CandidatePipeline";
import { InterviewScheduling } from "@/pages/employer/ComingSoonPages";
import EmployerBilling from "@/pages/employer/EmployerBilling";
import TalentMarketplace from "@/pages/employer/TalentMarketplace";
import EmployerTeam from "@/pages/employer/EmployerTeam";
import PostJob from "@/pages/employer/PostJob";
import JobReviewFromIntake from "@/pages/employer/JobReviewFromIntake";
import EmployerApplications from "@/pages/employer/EmployerApplications";
import EmployerInbox from "@/pages/employer/EmployerInbox";
import EmployerMessages from "@/pages/employer/EmployerMessages";
import BrowseTalent from "@/pages/employer/BrowseTalent";
import CompanyBranding from "@/pages/employer/CompanyBranding";
import EmployerTemplates from "@/pages/employer/EmployerTemplates";
import EmployerReferrals from "@/pages/employer/EmployerReferrals";
import EmployerScheduler from "@/pages/employer/EmployerScheduler";
import EmployerNotFound from "@/pages/employer/EmployerNotFound";
import ActivityPage from "@/pages/ActivityPage";

export function employerRoutes() {
    return (
        <Route path="/employer" element={<EmployerLayout />}>
            <Route index element={<Navigate to="/employer/dashboard" replace />} />
            <Route path="dashboard" element={<EmployerDashboardV2 />} />
            <Route path="find-talent" element={<FindTalent />} />
            <Route path="jobs" element={<EmployerJobs />} />
            <Route path="jobs/new" element={<PostJob />} />
            <Route path="jobs/review/:intakeId" element={<JobReviewFromIntake />} />
            <Route path="applications" element={<EmployerApplications />} />
            <Route path="inbox" element={<EmployerInbox />} />
            <Route path="messages" element={<EmployerMessages />} />
            <Route path="jobs/:jobId/browse" element={<BrowseTalent />} />
            <Route path="templates" element={<EmployerTemplates />} />
            <Route path="referrals" element={<EmployerReferrals />} />
            <Route path="scheduler" element={<EmployerScheduler />} />
            <Route path="branding" element={<CompanyBranding />} />
            <Route path="briefs" element={<EmployerDashboard />} />
            <Route path="pipeline" element={<CandidatePipeline />} />
            <Route path="marketplace" element={<TalentMarketplace />} />
            <Route path="scheduling" element={<InterviewScheduling />} />
            <Route path="team" element={<EmployerTeam />} />
            <Route path="billing" element={<EmployerBilling />} />
            <Route path="activity" element={<ActivityPage />} />
            {/* Catch-all — any unknown /employer/* path renders a friendly
                404 inside the layout instead of a blank white page. */}
            <Route path="*" element={<EmployerNotFound />} />
        </Route>
    );
}
